<template>

    <form class="mt-2" id="form-modal">
        
        
        <div class="col-md-12 px-0" >
            <div v-if="action != 'extend_due_date'">
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Title<span style="color: red">*</span>:</label>
                    <input type="text" v-model="task.title" class="form-control" placeholder="Title" />
                    
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Description<span style="color: red">*</span>:</label>
                    <div class="text_editor">
                        <tiny-mce-editor :vModelName.sync="task.description"></tiny-mce-editor><br />
                    </div>
                </div>
               
                <div v-if="action != 'add_task_from_Support_ticket' && (action == 'create' ||  action == 'assign_to') && role != 10" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Due Date</label>            
                    <input type="date" v-model="task.due_date" class="form-control" placeholder="Due Date" />
                </div>
                <!-- Required only for csm -->
                <div v-if="action != 'add_task_from_Support_ticket' && action == 'create'" class="form-group"> 
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Required Due Date<span v-if="[userRoles.csm, userRoles.super_admin].includes(role)" style="color: red">*</span>:</label>            
                    <input type="date" v-model="task.req_due_date" class="form-control" placeholder="Due Date" />
                </div>
                <div v-if="action != 'add_task_from_Support_ticket' && action == 'create' && [userRoles.admin,userRoles.super_admin,userRoles.adh,userRoles.developer,userRoles.adh_helper].includes(role)" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer Due Date</label>            
                    <input type="date" v-model="task.dev_due_date" class="form-control" placeholder="Due Date" />
                </div>
                <div v-if="action != 'add_task_from_Support_ticket' && action == 'create' && [userRoles.admin,userRoles.super_admin,userRoles.adh,userRoles.developer,userRoles.adh_helper].includes(role)" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">ADH Due Date</label>            
                    <input type="date" v-model="task.adh_due_date" class="form-control" placeholder="Due Date" />
                </div>
               
                <div v-if="action != 'assign_to' && action !== 'edit' && action!=='create'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Task Type<span style="color: red">*</span>:</label>
                    <!-- <input type="text" class="form-control"  placeholder="Priority" /> -->
                     <multiselect v-model="task_type" :options="taskTypesList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                     :selectLabel="null" :internal-search="true" label="name" track-by="value" placeholder="Task Type">
                    </multiselect>
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Priority<span style="color: red">*</span>:</label>
                    <!-- <input type="text" class="form-control"  placeholder="Priority" /> -->
                     <multiselect v-model="priority" :options="prioritiesList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                     :selectLabel="null" :internal-search="true" label="name" track-by="value" placeholder="Priority">
                    </multiselect>
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Customer<span style="color: red">*</span>:</label>            
                    <multiselect :options="organizations" :allow-empty="true" :searchable="true" :multiple="true"
                        :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" v-model="organizations_selected" label="name" track-by="id"></multiselect>
                </div>
                <div  v-if="action !== 'assign_to' && action !== 'edit' && action!=='create'"  class="form-group">
                    <label class="label-form" style="color: #48a6a6; font-weight: 600; font-size: 14px">Team</label>
                    <multiselect   :options="teams"   :selectedLabel="null" :deselectLabel="null" :allow-empty="true"
                        v-model="user.team" :selectLabel="null" :internal-search="true" label="name" track-by="id" placeholder="Team">
                    </multiselect>
                </div>
                <div v-if="[userRoles.development_lead].includes(role)"  class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer<span style="color: red">*</span>:</label>
                    <multiselect v-model="assigned_to" :options="allDevelopers" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" 
                        :selectLabel="null" :searchable="true" label="full_name" track-by="id" style="font-size:12px !important" >
                    </multiselect> 
                </div>
            </div>
            <div v-if="action == 'extend_due_date'"> 
                <div v-show="task.prev_due_date" class="form-group">
                    <p>Due-Date is {{task.prev_due_date | formatDate}}</p>
                </div>
                <!-- <div class="form-group">
                    <label class="label-form"  style="color: rgb(72, 166, 166); font-weight: 600; font-size: 14px">Due-Date<span style="color: red">*</span>:</label>
                    <multiselect  :options="due_date_types"  placeholder='Select Due-Date Type' @input="updateStatus" :multiple="false"
                        :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" 
                        v-model="due_date_type" label="type" track-by="value" style="font-size:12px !important">
                    </multiselect>
                </div> -->
                <div class="form-group">
                    <label  style="color: #48a6a6; font-weight: 600; font-size: 14px">Enter date to which you want to extend due-date<span style="color: red">*</span>:</label>
                    <input class="form-control" :min="task.min_date" type="date" placeholder="Due Date" v-model="task.extend_due_date">
                </div>
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Reason<span style="color: red">*</span>:</label>
                    <textarea type="text"  v-model="task.extend_due_date_comment" class="form-control" placeholder="Reason" />                   
                </div>
            </div>
            <!-- <div v-if="action != 'moveToDevelopment' && action != 'extend_due_date'">
                <div v-if="action != 'moveToDevelopment' && action != 'extend_due_date'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Due Date<span style="color: red">*</span>:</label>            
                    <input type="date" v-model="due_date" class="form-control" placeholder="Due Date" />
                </div>
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer<span style="color: red">*</span>:</label>
                    <multiselect v-model="developer" :options="formData.developers" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" 
                    label="full_name" track-by="id" style="font-size:12px !important">
                  </multiselect> 
                </div>
            </div> -->
            <!-- buttons -->
            <div class="text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button :style= "[mini_loading ? { 'pointer-events' : 'none' } : { 'pointer-events' : 'auto' }]" type="button" class="btn btn-default ml-1" @click="save">
                    <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    {{action != 'edit' ? "Save" : "Update"}} 
                </button>
            </div>
            <table v-if="[userRoles.admin,userRoles.super_admin,userRoles.adh].includes(role) && action == 'extend_due_date'" class="table table-bordered table-hover  mt-5 text-center">
                <th style="color:#48a6a6;" colspan="3"><b>Due Date History</b></th>
                <tbody>
                    <tr>
                    <th style="width: 35%;">Due Date</th>
                    <th style="width: 30%;">At</th>
                    <th style="width: 35%;">Updated By</th>
                    </tr>
                    <tr  v-if="loader" id="table_row" >
                        <td colspan="16">
                        <b-skeleton-wrapper >
                            <b-skeleton height="40px" ></b-skeleton>   
                            <b-skeleton height="40px"></b-skeleton>  
                            <b-skeleton height="40px"></b-skeleton>                                     
                        </b-skeleton-wrapper> 
                        </td>
                    </tr>
                    <tr v-else class="mt-2" v-for="dueDateRow in due_date_history" :key="dueDateRow.id">
                        <td  style="width: 35%;"> <p style="white-space: break-spaces">{{ dueDateRow.due_date |formatDate }}</p> </td>
                        <td  style="width: 30%;"> <p style="white-space: break-spaces">{{ dueDateRow.created_at |formatCreatedAtDate}}</p> </td>
                        <td style="width: 35%;"> <p style="white-space: break-spaces">{{ dueDateRow.created_by.first_name }} {{ dueDateRow.created_by.last_name }}</p> </td>
                    </tr>
                    <tr v-if="!loader && due_date_history.length < 1">
                        <td  colspan="3">
                            No Due-Date History Found.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
    
</template>

<script>
    import Multiselect from "vue-multiselect";
    import axios from 'axios';
    import moment from "moment";
    import TinymceEditor from "../../../../views/partials/tiny_mce_editor";
  import { mapGetters } from 'vuex';
    Vue.filter("formatDate", function (value) {
        if (value != "0000-00-00" && value != null) {
            return moment(String(value)).format("DD MMM,Y");
        }
    });
    Vue.filter("formatCreatedAtDate", function (value) {
        if (value != "0000-00-00" && value != null) {
            return moment(String(value)).format("DD MMM,Y h:mm a");
        }
    });
    export default {
        components: {
            Multiselect,
            "tiny-mce-editor": TinymceEditor,
        },
        props:  ['formData','action', 'testData'],
        data: function(){
            return{
                task: {
                    id: null, 
                    title: '', 
                    description: '', 
                    due_date: '', 
                    req_due_date:'',
                    dev_due_date:'',
                    adh_due_date:'',
                    status: 1, 
                    assigned_to_selected: {}, 
                    task_type_selected: {}, 
                    priority_selected: {}, 
                    organizations_selected: [],
                    support_ticket_id: '',
                    prev_due_date:'',
                    extend_due_date: '',
                    extend_due_date_comment: '',
                    activity_type: '',
                    prms:'',
                    min_date: '',
                    user_team: [],
                    
                },
                loader:true,
                assigned_to:{},
                task_type:{},
                priority:{},
                organizations_selected:{},
                due_date_history: [],
                taskForm:{},
                organizations: [],
                org: '',
                org_search_value: "all",
                developers:[],
                mini_loading:false,
                role: JSON.parse(localStorage.getItem("role")),
                user: this.get_empty_user_obj(),
                team_developers :[],
                allDevelopers : [],

                
                
                // due_date_types:[
                //     {"value":0,"type":"Due Date"},
                //     {"value":1,"type":"Developer Due Date"},
                //     {"value":2,"type":"ADH Due Date"}
                // ],
               

            };
        },
        computed: {
            prioritiesList: function () {
                return this.$store.getters['tasks/prioritiesList'];
            },
            activityTypes: function () {
                return this.$store.getters['tasks/activityTypes'];
            },
            taskTypesList: function () {
                return this.$store.getters['tasks/taskTypesList'];
            },
            userRoles: function () {
				return this.$store.getters['persist/userRoles'];
			},
            ...mapGetters('persist', ['teams']),
        },
        mounted: function(){
            this.on_load_component();
        },
        created: function () {
            this.getOrganizations();
            
        },
        watch:{
            formData: {
                handler: 'on_load_component', // Replace 'onFormDataChange' with the actual method name
                deep: true, // Optional, if you need to deep watch for changes
            },
            'user.team': function(newTeam, oldTeam) {
               
                    if (newTeam !== oldTeam) {
                    this.team_developers = newTeam.team_developer
                    .filter(developer =>
                        this.formData.developers.some(alldev =>
                        alldev.id === developer.user_id
                        )
                    )
                    .map(developer => developer.user_id);

                    this.allDevelopers = this.formData.developers.filter(developer =>
                    this.team_developers.includes(developer.id)
                    );
                }
                    if (oldTeam && oldTeam.team_developer) {
                        this.assigned_to = {};
                    }
                }

               ,
        },
        methods: {
            get_empty_user_obj() {
                return { user_name: '', password: '', first_name: '', last_name: '', email: '', role_id: '',team:[], client_id: '', client_secret: '',account_id: '' };
            },
            on_load_component () {
                if (this.action == 'edit') {
                    this.task = { ...this.formData.task };
                    // this.task.due_date = task.due_date != '' ? moment(new Date(task.due_date).toISOString()).format("Y-MM-DD") : ''
                    this.task.due_date = this.task.due_date ? new Date(this.task.due_date).toISOString().slice(0, 10) : '';
                    this.task.req_due_date = this.task.req_due_date ? new Date(this.task.req_due_date).toISOString().slice(0, 10) : '';
                    this.task.dev_due_date = this.task.dev_due_date ? new Date(this.task.dev_due_date).toISOString().slice(0, 10) : '';
                    this.task.adh_due_date = this.task.adh_due_date ? new Date(this.task.adh_due_date).toISOString().slice(0, 10) : '';
                    this.task.status = this.task.status;
                    this.assigned_to =  {full_name: this.task.assigned_to.name, id: this.task.assigned_to.id};
                    // this.task.assigned_to_selected =  this.assigned_to;
                    this.task_type = this.taskTypesList.find(opt => opt.value == this.task.task_type);
                    this.priority= this.prioritiesList.find(opt => opt.value == this.task.priority);
                    this.user.team= this.teams.find(opt => opt.id === this.task.team_id);
                    // this.organizations_selected = this.task.organizations_obj;
                } else if (this.action == 'add_task_from_Support_ticket') {
                    this.task.support_ticket_id = this.formData.ticket_id;
                    this.task.status = 0;
                    this.task.title = this.formData.ticket_title;
                    this.organizations_selected = [this.organizations.find(opt => opt.name === this.formData.organization)];
                } else if (this.action == 'extend_due_date') {
                    this.task = { ...this.formData.task };
                    this.task.activity_type = parseInt(this.formData.type);
                    this.task.prms=this.formData.prms
                    // if(this.activityTypes.extendADHDueDate == this.task.activity_type)
                    //     this.task.prev_due_date = this.task.adh_due_date ? new Date(this.task.adh_due_date).toISOString().slice(0, 10) : '';
                    // else if(this.activityTypes.extendDeveloperDueDate == this.task.activity_type)
                    //     this.task.prev_due_date = this.task.dev_due_date? new Date(this.task.dev_due_date).toISOString().slice(0, 10) : "";
                    // else
                    //     this.task.prev_due_date = this.task.due_date ? new Date(this.task.due_date).toISOString().slice(0, 10):'';
                    this.getDueDateHistory();
                } else if (this.action == 'assign_to') {
                    this.task = { ...this.formData.task };
                    this.task.due_date='';
                   this.user.team= this.teams.find(opt => opt.id === this.task.team_id);
                }else if (this.action == 'create') {
                    this.task.id= null;
                    this.task.title= ''; 
                    this.task.description= '', 
                    this.task.due_date= '', 
                    this.task.status= 1, 
                    this.assigned_to={};
                    this.task_type={};
                    this.organizations_selected=[];
                    this.task.support_ticket_id= '';
                    this.task.extend_due_date= '';
                    this.task.extend_due_date_comment= '';
                }
            },
            async getOrganizations(){
                await this.$store.dispatch("organizations/getAll",[{status: 1}]).then((res) => {
                   this.organizations = res;
                    if(this.action == 'add_task_from_Support_ticket'){
                        this.organizations_selected = [this.organizations.find(opt => opt.name === this.formData.organization)];
                    }else if( this.action == "edit"){
                        let sel_orgs = [];
                        this.formData.task.organizations_obj.forEach((key) => {
                            this.organizations.find(opt => opt.id === this.formData.task.organizations_obj.organization_id);
                            sel_orgs.push({id:key.organization_id,name:key.name});
                    
                    });
                    this.organizations_selected = sel_orgs;
                    }
                });
            },
            save(){
                if(this.user && this.user.team && this.user.team.id !== null && this.user.team.id !== undefined)
                {
                    this.task.user_team = this.user.team.id;

                }else{
                    this.task.user_team=1;
                }
                this.mini_loading = true;
                let method = '';
                let is_form_valid = true;

                if(this.action == 'create' || this.action == 'edit'){
                    is_form_valid = this.validateCreateUpdateForm();
                            if (Object.values(this.assigned_to).length<1) {
                                this.task.status = 0;
                        }else{
                                this.task.status = 1;
                            }
                    if(this.task.req_due_date == '' && this.task.due_date && this.action == 'create'){
                        this.task.req_due_date = this.task.due_date;
                    }
                    method = (this.action == 'create')? "addTask": "updateTask";
                    if(method === "updateTask"){
                        this.task.assigned_to_selected =this.assigned_to;
                        this.user_team =this.user.team;
                    }
                    this.task.task_type=1;
                }else if(this.action == 'add_task_from_Support_ticket'){
                    method = "addTask";
                    is_form_valid = this.validateAddTaskFromSupportTicketForm();
                }else if(this.action == 'extend_due_date'){
                    method = "extendDueDateDesignerTask";
                    is_form_valid = this.validateExtendDueDateForm();
                }else if(this.action == 'assign_to'){
                    method = "assignDesignerTask";
                    is_form_valid = this.validateAssignedToForm();
                    if (Object.values(this.assigned_to).length<1) {
                                this.task.status = 0;
                            }
                   
                }

                if (is_form_valid) {
                    this.$store.dispatch("tasks/"+method, [this.task]).then((response) => {
                        this.mini_loading = false;
                        if(response && response.error){
                            this.serverValidationErrors(response.error);
                        }else{
                            this.skeletonLoader = true;
                            if(this.action != 'add_task_from_Support_ticket'){
                                let filtersData = [this.$store.getters['tasks/currentPage'], this.$store.getters['tasks/filters'], []]
                                this.$store.dispatch("tasks/getAllDesignerTask", filtersData).then(() => {
                                    window.$('#modal').modal('hide');
                                    this.$toast.success(response);
                                    this.skeletonLoader = false;
                                });
                            }else{
                                this.$toast.success(response);
                                window.$('#modal').modal('hide');
                            }
                        }
                    });
                } else {
                    this.mini_loading = false;
                }
            },
            validateCreateUpdateForm () {
                if(this.task.title == '' || this.task.description == '' || this.priority.value == undefined || 
                        this.organizations_selected.length == 0 ){
                    if (this.task.title == '') {
                        this.$toast.error('The title field is required');
                    }
                    if (this.task.description == '' ) {
                        this.$toast.error('The description field is required');
                    }

                    if (this.task.req_due_date == ''&&(this.role == 4 || this.role == 10)) {
                        this.$toast.error('The Requird due date field is required');
                    }
                    // if(this.task.assigned_to_selected.id == undefined){
                    //     this.$toast.error('The developer field is required');
                    // }
                    // if(this.task_type.value == undefined){
                    //     this.$toast.error('The task type field is required');
                    // }
                    if(this.priority.value == undefined){
                        this.$toast.error('The priority field is required');
                    }
                    if(this.organizations_selected.length == 0){
                        this.$toast.error('The customers field is required');
                    }
                    return false;
                }else{
                    this.task.assigned_to = this.assigned_to.id;
                    if (this.action != 'edit') 
                        this.task.status = (this.assigned_to.id == undefined) ? 0 : 1;
                    this.task.priority = this.priority.value;
                    this.task.task_type = this.task_type.value;
                    this.task.organizations = this.organizations_selected.map(({ id }) => id);
                    return true;
                }
            },
            validateAddTaskFromSupportTicketForm () {
                if(this.task.title == '' || this.task.description == '' || this.priority.value == undefined){
                    if (this.task.title == '') {
                        this.$toast.error('The title field is required');
                    }
                    if (this.task.description == '' ) {
                        this.$toast.error('The description field is required');
                    }
                    // if(this.task_type.value == undefined){
                    //     this.$toast.error('The task type field is required');
                    // }
                    if (this.priorityvalue == undefined) {
                        this.$toast.error('The priority field is required');
                    }
                    if(this.organizations_selected.length == 0){
                        this.$toast.error('The customers field is required');
                    }
                    this.mini_loading=false;
                    return false;
                }else{
                    this.task.priority = this.priority.value;
                    this.task.task_type = this.task_type.value;
                    this.task.organizations = this.organizations_selected.map(({ id }) => id);
                    return true;
                }
            },
            validateExtendDueDateForm () {
                if (this.task.extend_due_date == ''|| this.task.extend_due_date === undefined || this.task.extend_due_date_comment == '' || this.task.extend_due_date_comment === undefined) {
                    if (this.task.extend_due_date_comment == '' || this.task.extend_due_date_comment === undefined) {
                        this.$toast.error('Reason field is required.');
                    }
                    if ( this.task.extend_due_date == '' || this.task.extend_due_date === undefined) {
                        this.$toast.error('Date field is required.');
                    }
                   
                    this.mini_loading=false;
                    return false;
                } else {
                    return true;
                }
            },
            getDueDateHistory () {
                this.loader = true;
                this.$store.dispatch("tasks/getdesignerActivity",[this.task.id,this.formData.type]).then((response) => {
                    this.due_date_history = response;
                    this.task.prev_due_date = this.due_date_history.length > 0 ? this.due_date_history[this.due_date_history.length-1].due_date:'';
                    if(this.task.prev_due_date){
                        this.task.min_date = this.task.prev_due_date;  
                    }else{
                        this.task.min_date = new Date().toISOString().slice(0, 10);
                    }
                    this.loader = false;
                });
            },
            getCurrentDueDate(){
                this.$store.dispatch("tasks/getCurrentDueDate",[this.taskForm]).then((response) => {
                    this.due_date_history = response.due_date;
                });
            },
            validateAssignedToForm(){
                if(this.task.due_date==''){
                    if(this.task.due_date == ''){
                        this.$toast.error('The due date field is required');
                    }
                    // if(this.assigned_to.id == undefined){
                    //     this.$toast.error('The developer field is required');
                    // }
                    this.mini_loading=false;
                    return false;
                }else{
                    this.task.assigned_to = this.assigned_to.id;
                    this.task.status = 1;
                    return true;
                }
            },
            serverValidationErrors(error = []){
                if(error.hasOwnProperty('title')){
                     this.$toast.error('The title field is required');
                }
                if(error.hasOwnProperty('description')){
                     this.$toast.error('The description field is required');
                }
                if(error.hasOwnProperty('due_date')){
                     this.$toast.error('The due date field is required');
                }
                // if(error.hasOwnProperty('assigned_to')){
                //    this.$toast.error('The developer field is required');
                // }
                if(error.hasOwnProperty('priority')){
                    this.$toast.error('The priority field is required');
                }
            },
        }
    }
</script>
<style scoped>
input[type="date"]{
  position: relative;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 6px !important;
    right: 2%;
    width: auto;
}
.text-dark{
    color: rgb(72, 166, 166) !important;
}
</style>